import React, { lazy, Suspense, type ReactElement } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'

const LazyChangePasswordPage = lazy(() =>
  import('../pages/ChangePassword').then((module) => ({ default: module.ChangePasswordPage })),
)

export const ChangePasswordRoute = (): ReactElement => {
  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyChangePasswordPage />
    </Suspense>
  )
}
